import './App.css'

import { FormTest } from '../components/FormTest'

// const inputTypes = {
//   "text": <input type="text" id="username" name="data" autoComplete="off"/>,
//   "password": <input type="password" id="password"/>,
// }

function App() {

  const inputTypes = ["text"];
  const nameInput = ["Domain"];
  const idInput = ["domain"];

  return (

    <>
      <h2 className='prueba'>Dominios ya</h2>

      <FormTest 
        inputTypes={inputTypes}
        nameInput={nameInput}
        idInput={idInput}
      />
    </>
    
  );
}

export default App;
